import moment from 'moment';
import { GetBusinessDetails_getBusiness } from '../../../graphql/business/types/GetBusinessDetails';

export interface IUser {
  id: number;
  firstName: string;
  lastName: string | null;
}

export interface IApa extends IUser {
  enseigneName?: string;
}

export interface IStep {
  id: number;
  label: string;
  name: string | null;
}

export interface IBank {
  id: number;
  name: string;
}

export interface IBeneficiary {
  id: number;
  firstName: string;
  lastName: string | null;
}

export interface ICommission {
  id: number;
  beneficiary: IBeneficiary | null;
  amount: number | null;
  isNew: boolean;
}

export interface IBusiness {
  id: number;
  idCRM: number | null;
  firstName: string;
  lastName: string | null;
  createdAt: any;
  unblockedAt?: any;
  signedByNotaryAt?: any;
  phone: string | null;
  email: string;
  manager: IUser | null;
  mandatary: IUser | null;
  apa: IApa;
  step: IStep;
  CRMStep: IStep;
  bank: IBank | null | undefined;

  remunerationId: number | null | undefined;
  clientHonorary: number | null | undefined;
  bankCommission: number | null | undefined;
  apaCommissions: ICommission[] | null;
  mandaCommissions: ICommission[] | null;

  estimatedMaxPurchase?: number | null | undefined;
  estimatedMaxLoan?: number | null | undefined;
}

export const InitialBusiness: IBusiness = {
  id: 0,
  firstName: '',
  lastName: '',
  createdAt: '',
  phone: '',
  email: '',
  manager: {
    id: 0,
    firstName: '',
    lastName: '',
  },
  mandatary: {
    id: 0,
    firstName: '',
    lastName: '',
  },
  apa: {
    id: 0,
    firstName: '',
    lastName: '',
    enseigneName: '',
  },
  step: {
    id: 0,
    label: '',
    name: '',
  },
  CRMStep: {
    id: 0,
    label: '',
    name: '',
  },

  remunerationId: null,
  clientHonorary: null,
  bankCommission: null,

  bank: null,

  apaCommissions: null,
  mandaCommissions: null,

  idCRM: null,
};

export const getFullName = ({
  firstName,
  lastName,
  firstNameFirt,
}: {
  firstName: string;
  lastName: string | null;
  firstNameFirt?: boolean;
}) => {
  const fullName = `${firstName} ${lastName ? lastName : ''}`;

  const fullNameFirstNameFirst = `${firstName} ${lastName ? lastName : ''}`;

  return firstNameFirt ? fullNameFirstNameFirst : fullName;
};

export const formatDate = (date: any) => {
  const formatedDate = date
    ? `${moment(date).format('DD-MM-YYYY')} à ${moment(date).format('HH:mm')}`
    : '--/--';

  return formatedDate;
};

export const mapBusinessDataToState = (
  businessData: GetBusinessDetails_getBusiness,
): IBusiness => {
  const {
    remuneration,
    possibleSteps,
    apaCommissions,
    mandaCommissions,
    ...otherInfos
  } = businessData;
  return {
    ...otherInfos,
    remunerationId: remuneration?.id,
    clientHonorary: remuneration?.clientHonorary,
    bankCommission: remuneration?.bankCommission,
    bank: remuneration?.bank,
    apaCommissions:
      apaCommissions &&
      apaCommissions?.map((commission) => ({ ...commission, isNew: false })),
    mandaCommissions:
      mandaCommissions &&
      mandaCommissions?.map((commission) => ({ ...commission, isNew: false })),
  };
};

export const thousandSeparator = (value: string) => {
  if (value) {
    return value.replace(/\s/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  return value;
};

export const sum = (numbers: (number | null | undefined)[]) => {
  let sum = 0;
  for (const number of numbers) {
    if (number) sum = sum + number;
  }

  return sum;
};
